import io  from 'socket.io-client'

const _io = io
const sock = _io.connect('http://visualdiet.mcsdh.com:3000')
let currentImage

export function emotionDetection(el) {

  if(!el) {
    return
  }

    sock.on('image', (data) => {
    	currentImage = data.id
    	let timer = setTimeout(()=> {
    		take_snapshot()
    		clearTimeout(timer)
    	}, 2000)
  	})
	
     var params = {
            "returnFaceId": "true",
            "returnFaceLandmarks": "false",
            "returnFaceAttributes":
                "age,gender,smile,emotion," +
                "noise"
    }

    Webcam.set({
        width: 900,
        height: 506,
        image_format: 'jpeg',
        jpeg_quality: 90
    })
    
    Webcam.attach(document.getElementById('camera'))

    const canvas = document.getElementById('viewport'),
    context = canvas.getContext('2d')

    const take_snapshot = () => {

        Webcam.snap((data_uri) => {
        let base_image = new Image()
        base_image.src = data_uri
        base_image.onload = function() {
	        context.drawImage(base_image, 0, 0, 900, 506)

	        let data = canvas.toDataURL('image/jpeg')

			fetch(data)
			.then(res => res.blob())
			.then(blobData => {

				let urlParams = Object.keys(params).map((k) => {
					return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
				}).join('&')

				let xmlHttp = new XMLHttpRequest();
				xmlHttp.onreadystatechange = () =>	{
					if(xmlHttp.readyState == 4 && xmlHttp.status == 200)	{
				 	let result = JSON.parse(xmlHttp.responseText)
						if(result.length) { 
							castVote(result[0].faceAttributes.emotion)
						}
					} 
				}

				xmlHttp.open('post', `https://uksouth.api.cognitive.microsoft.com/face/v1.0/detect?${urlParams}`)
				xmlHttp.setRequestHeader('Content-Type', 'application/octet-stream')
				xmlHttp.setRequestHeader('Ocp-Apim-Subscription-Key', '743da3e166c94106b5489a58fd289375')
				xmlHttp.send(blobData)
			})
			.catch(error => console.error('Error:', error))
	        }
      	})
    }

    const castVote = (emotion) => {
    	console.log('casting vote.....')
    	let sorted = Object.keys(emotion).sort((a,b) => emotion[b] - emotion[a])
    	let voteDirection
		
  		switch (sorted[0]) {
  			case 'anger':
     			case 'contempt':
     			case 'disgust':
     			case 'fear': 
     				voteDirection = 'down'
         		break;
         		case 'happiness':
         		case 'surprise':
         			voteDirection = 'up'
         		break;
         		default: 
         			voteDirection = 'down'
         		break;
  		}

  		sock.emit('vote', {'id' : currentImage, 'sentiment' : voteDirection})

    }
	
}


// WEBPACK FOOTER //
// ./js/emotion-detection.js